(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper')
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-template"]) return;
  try {
    
    const getpagi = document.querySelector('.AjaxinatePagination');
    if(typeof(getpagi) !== "undefined" && getpagi !== null){
      document.addEventListener("DOMContentLoaded", function() {
        const elem = getpagi.getAttribute('data-pagination');
        var endlessScroll = new Ajaxinate({
          container: '.AjaxinateLoop',
          pagination: '.AjaxinatePagination',
          loadingText: '<span class="loader-line"></span>',
          method: elem == 'scroll' ? 'scroll' : 'click'
        });
      });
    }
    
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["parallax-banner"] && !Shopify.designMode) return;
  try {
    
  class ParallaxImage extends HTMLElement {
    constructor() {
      super();
      
    }
  connectedCallback() {
    const sectionId = this.getAttribute('section-id');
    const image = this.querySelector('img');
    const aosAnimation = this.getAttribute('data-aos');

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          window.addEventListener('scroll', this.parallaxEffect);
        } else {
          window.removeEventListener('scroll', this.parallaxEffect);
        }
      });
    });

    const section = document.getElementById(sectionId);
    observer.observe(section);

    const imageContainer = this;
    imageContainer.style.transform = 'translateY(0)';

    this.parallaxEffect = () => {
      const scrollPosition = window.pageYOffset;
      const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
      const parallaxValue = (scrollPosition / maxScroll) * 50;
      image.style.transform = `translateY(-${parallaxValue}%) scale(1.2)`;
    };

  }
}

customElements.define('parallax-image', ParallaxImage);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["postershop-photo-personalizer"] && !Shopify.designMode) return;
  try {
    
(()=>{document.querySelectorAll('[data-psp5]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='1';const TEMPLATE='standing-reference-5-photo-shapes-v5',MAX_BYTES=20*1024*1024,MAX_PIXELS=60000000,TITLE_FONT_FACTOR=.55,LAYOUT={padOfWidth:.053,titleHeightOfHeight:.09,titleGapOfWidth:.034,columnGapOfPhotosWidth:.041,rowGapOfPhotosHeight:.025},slots=[...root.querySelectorAll('[data-slot]')],files=[...root.querySelectorAll('[data-file]')],rows=[...root.querySelectorAll('[data-row]')],defaultShapes=['arch','circle','heart','rect','blob'],states=Array.from({length:5},(_,i)=>({file:null,url:'',zoom:1,crop:null,shape:defaultShapes[i],w:0,h:0,seq:0})),poster=root.querySelector('[data-poster]'),zoom=root.querySelector('[data-zoom]'),editor=root.querySelector('[data-editor]'),active=root.querySelector('[data-active]'),cropInput=root.querySelector('[data-crop]'),shapesInput=root.querySelector('[data-shapes]'),personalizationId=root.querySelector('[data-personalization-id]'),shapeButtons=[...root.querySelectorAll('[data-shape]')],quality=root.querySelector('[data-quality]'),qualitySummary=root.querySelector('[data-quality-summary]'),count=root.querySelector('[data-count]'),msg=root.querySelector('[data-msg]'),variant=root.querySelector('[data-variant]'),sizeInput=root.querySelector('[data-psp-size-input]'),price=root.querySelector('[data-price]'),submitPrice=root.querySelector('[data-submit-price]'),titleInput=root.querySelector('[data-title-input]'),titlePreview=root.querySelector('[data-title-preview]'),form=root.querySelector('form.psp5__form'),submitButton=root.querySelector('.psp5__submit'),sectionId=root.dataset.sectionId;let current=0,drag=null,layout=null,submitting=false;const clamp=(v,a,b)=>Math.min(b,Math.max(a,v)),round4=v=>+Number(v).toFixed(4);if(personalizationId&&!personalizationId.value)personalizationId.value=(globalThis.crypto&&crypto.randomUUID)?crypto.randomUUID():'psp_'+Date.now().toString(36)+'_'+Math.random().toString(36).slice(2,10);const maskUrl=shape=>shape==='rect'?'none':'url("#psp5-'+shape+'-'+sectionId+'")';const selectedSizeKey=()=>variant?.options[variant.selectedIndex]?.dataset.pspSize||'';const selectedSize=()=>{const raw=selectedSizeKey();const m=raw.match(/^(\d+(?:[.,]\d+)?)x(\d+(?:[.,]\d+)?)$/i);return m?[parseFloat(m[1].replace(',','.')),parseFloat(m[2].replace(',','.'))]:null};const computeLayout=(W,H)=>{const pad=Math.round(W*LAYOUT.padOfWidth),titleH=Math.round(H*LAYOUT.titleHeightOfHeight),titleGap=Math.round(W*LAYOUT.titleGapOfWidth),photosH=H-pad*2-titleH-titleGap,photosW=W-pad*2,colGap=Math.round(photosW*LAYOUT.columnGapOfPhotosWidth),colW=Math.round((photosW-colGap)/2),rowGap=Math.round(photosH*LAYOUT.rowGapOfPhotosHeight),leftH=Math.round((photosH-rowGap)/2),rightH=Math.round((photosH-rowGap*2)/3),rightX=pad+colW+colGap;return{pad,titleH,title:{x:pad,y:H-pad-titleH,w:W-pad*2,h:titleH},boxes:[{x:pad,y:pad,w:colW,h:leftH},{x:pad,y:pad+leftH+rowGap,w:colW,h:leftH},{x:rightX,y:pad,w:colW,h:rightH},{x:rightX,y:pad+rightH+rowGap,w:colW,h:rightH},{x:rightX,y:pad+(rightH+rowGap)*2,w:colW,h:rightH}]}};const applyAspect=()=>{const size=selectedSize();if(!size){msg.textContent='Den valgte størrelse understøttes ikke til personalisering.';return false}const[w,h]=size;poster.style.setProperty('--psp-w',w);poster.style.setProperty('--psp-h',h);return true};const setBox=(el,b)=>{el.style.left=b.x+'px';el.style.top=b.y+'px';el.style.width=b.w+'px';el.style.height=b.h+'px'};const fitTitle=()=>{if(!layout)return;setBox(titlePreview,layout.title);const text=(titleInput?.value||'DIN TITEL').trim().toUpperCase()||'DIN TITEL',canvas=document.createElement('canvas'),ctx=canvas.getContext('2d');let size=Math.max(12,layout.title.h*TITLE_FONT_FACTOR);ctx.font='400 '+size+'px sans-serif';while(ctx.measureText(text).width>layout.title.w&&size>10){size-=1;ctx.font='400 '+size+'px sans-serif'}titlePreview.style.fontSize=size+'px'};const applyLayout=()=>{const W=Math.round(poster.clientWidth),H=Math.round(poster.clientHeight);if(!W||!H)return;layout=computeLayout(W,H);slots.forEach((slot,i)=>setBox(slot,layout.boxes[i]));fitTitle();states.forEach((s,i)=>{if(s.file)renderImage(i)})};const cropAtZoom=(i,newZoom,centre)=>{const s=states[i],b=layout?.boxes[i];if(!s.w||!s.h||!b)return null;const target=b.w/b.h,source=s.w/s.h;let cw,ch;if(source>=target){ch=s.h;cw=s.h*target}else{cw=s.w;ch=s.w/target}cw/=newZoom;ch/=newZoom;const cx=centre?.x??s.w/2,cy=centre?.y??s.h/2,left=clamp(cx-cw/2,0,s.w-cw),top=clamp(cy-ch/2,0,s.h-ch);return{x:left/s.w*100,y:top/s.h*100,width:cw/s.w*100,height:ch/s.h*100}};const cropCentrePx=s=>s.crop?{x:(s.crop.x+s.crop.width/2)/100*s.w,y:(s.crop.y+s.crop.height/2)/100*s.h}:{x:s.w/2,y:s.h/2};const renderImage=i=>{const s=states[i],slot=slots[i],img=slot.querySelector('[data-img]'),mask=slot.querySelector('[data-mask]'),b=layout?.boxes[i];if(!s.crop||!b||!s.w||!s.h)return;const cropW=s.w*s.crop.width/100,cropH=s.h*s.crop.height/100,scale=b.w/cropW,left=-(s.w*s.crop.x/100)*scale,top=-(s.h*s.crop.y/100)*scale;img.style.width=s.w*scale+'px';img.style.height=s.h*scale+'px';img.style.left=left+'px';img.style.top=top+'px';mask.style.clipPath=maskUrl(s.shape);mask.style.webkitClipPath=maskUrl(s.shape);sync()};const sync=()=>{cropInput.value=states.map(s=>s.crop?[s.crop.x,s.crop.y,s.crop.width,s.crop.height].map(round4).join(','):'').join('|');shapesInput.value=states.map(s=>s.shape).join('|');count.textContent=states.filter(s=>s.file).length+' / 5'};const slotPhysical=(i,cmW,cmH)=>{const W=10000,H=W*(cmH/cmW),L=computeLayout(W,H),b=L.boxes[i];return{w:b.w/W*cmW,h:b.h/H*cmH}};const qualityFor=i=>{const s=states[i],size=selectedSize();if(!s.file||!s.crop||!size)return null;const[cmW,cmH]=size,phys=slotPhysical(i,cmW,cmH),pxW=s.w*s.crop.width/100,pxH=s.h*s.crop.height/100,dpi=Math.round(Math.min(pxW/(phys.w/2.54),pxH/(phys.h/2.54)));if(dpi>=200)return{dpi,status:'good',label:'God'};if(dpi>=150)return{dpi,status:'ok',label:'Acceptabel'};return{dpi,status:'low',label:'For lav'}};const updateQualitySummary=()=>{qualitySummary.className='psp5__quality-summary';const loaded=states.map((s,i)=>s.file&&s.crop?qualityFor(i):null).filter(Boolean);if(!loaded.length){qualitySummary.textContent='';return}const low=loaded.filter(x=>x.status==='low'),ok=loaded.filter(x=>x.status==='ok'),min=Math.min(...loaded.map(x=>x.dpi));let cls='good',text='Samlet billedkvalitet: God';if(low.length){cls='low';text='Samlet billedkvalitet: For lav · '+low.length+' billede'+(low.length===1?'':'r')+' under 150 DPI'}else if(ok.length){cls='ok';text='Samlet billedkvalitet: Acceptabel · laveste ca. '+min+' DPI'}qualitySummary.classList.add(cls);qualitySummary.textContent=text};const updateQuality=i=>{quality.className='psp5__quality';const q=qualityFor(i);if(!states[i].file||!states[i].crop){quality.textContent='';updateQualitySummary();return}if(!q){quality.textContent='Ukendt størrelse';quality.classList.add('low');updateQualitySummary();return}quality.classList.add(q.status);quality.textContent='Billedkvalitet: '+q.label+' · ca. '+q.dpi+' DPI';updateQualitySummary()};const select=i=>{current=i;slots.forEach((x,j)=>x.classList.toggle('active',j===i));active.textContent='Billede '+(i+1);zoom.value=states[i].zoom;shapeButtons.forEach(b=>{const on=b.dataset.shape===states[i].shape;b.classList.toggle('is-active',on);b.setAttribute('aria-pressed',String(on))});editor.hidden=!states[i].file;updateQuality(i)};const clearSlot=i=>{const s=states[i];s.seq+=1;if(s.url)URL.revokeObjectURL(s.url);Object.assign(s,{file:null,url:'',zoom:1,crop:null,w:0,h:0});slots[i].classList.remove('has');slots[i].querySelector('[data-img]').removeAttribute('src');rows[i].classList.remove('done');rows[i].querySelector('[data-name]').textContent='Upload billede '+(i+1);rows[i].querySelector('[data-ok]').textContent='+';sync();updateQualitySummary()};const orientedDimensions=async file=>{if(typeof createImageBitmap!=='function')return null;let bitmap;try{bitmap=await createImageBitmap(file,{imageOrientation:'from-image'});return{w:bitmap.width,h:bitmap.height}}catch{return null}finally{bitmap?.close?.()}};const load=(i,file)=>{if(!file)return;if(file.size>MAX_BYTES){msg.textContent='Billede '+(i+1)+' er over 20 MB.';files[i].value='';return}if(!/^image\/(jpeg|png|webp)$/i.test(file.type)){msg.textContent='Billede '+(i+1)+' skal være JPG, PNG eller WebP.';files[i].value='';return}msg.textContent='';const s=states[i],seq=++s.seq;if(s.url)URL.revokeObjectURL(s.url);s.file=file;s.url=URL.createObjectURL(file);s.zoom=1;const im=new Image();im.onload=async()=>{const dims=await orientedDimensions(file);if(s.seq!==seq||s.file!==file)return;const w=dims?.w||im.naturalWidth,h=dims?.h||im.naturalHeight;if(w*h>MAX_PIXELS){msg.textContent='Billede '+(i+1)+' er for stort til sikker behandling.';files[i].value='';URL.revokeObjectURL(s.url);clearSlot(i);return}s.w=w;s.h=h;s.crop=cropAtZoom(i,1);const img=slots[i].querySelector('[data-img]');img.src=s.url;slots[i].classList.add('has');rows[i].classList.add('done');rows[i].querySelector('[data-name]').textContent=file.name;rows[i].querySelector('[data-ok]').textContent='✓';renderImage(i);select(i)};im.onerror=()=>{if(s.seq!==seq||s.file!==file)return;msg.textContent='Billede '+(i+1)+' kunne ikke læses.';files[i].value='';clearSlot(i)};im.src=s.url};files.forEach((f,i)=>f.addEventListener('change',()=>load(i,f.files?.[0])));rows.forEach((r,i)=>r.addEventListener('click',()=>{select(i);if(!states[i].file)files[i].click()}));slots.forEach((slot,i)=>{slot.addEventListener('click',()=>{select(i);if(!states[i].file)files[i].click()});slot.addEventListener('pointerdown',e=>{const s=states[i],b=layout?.boxes[i];if(!s.file||!s.crop||!b)return;e.preventDefault();select(i);slot.setPointerCapture(e.pointerId);drag={i,id:e.pointerId,sx:e.clientX,sy:e.clientY,start:{...s.crop}}});slot.addEventListener('pointermove',e=>{if(!drag||drag.i!==i||drag.id!==e.pointerId)return;const s=states[i],b=layout.boxes[i],start=drag.start,cropW=s.w*start.width/100,cropH=s.h*start.height/100,startLeft=s.w*start.x/100,startTop=s.h*start.y/100,left=clamp(startLeft-(e.clientX-drag.sx)/b.w*cropW,0,s.w-cropW),top=clamp(startTop-(e.clientY-drag.sy)/b.h*cropH,0,s.h-cropH);s.crop={x:left/s.w*100,y:top/s.h*100,width:start.width,height:start.height};renderImage(i);updateQuality(i)});['pointerup','pointercancel'].forEach(n=>slot.addEventListener(n,e=>{if(drag?.id===e.pointerId)drag=null}))});zoom.addEventListener('input',()=>{const s=states[current];if(!s.file)return;const centre=cropCentrePx(s);s.zoom=+zoom.value;s.crop=cropAtZoom(current,s.zoom,centre);renderImage(current);updateQuality(current)});shapeButtons.forEach(button=>button.addEventListener('click',()=>{states[current].shape=button.dataset.shape;renderImage(current);select(current)}));root.querySelector('[data-reset]').addEventListener('click',()=>{const s=states[current];if(!s.file)return;s.zoom=1;s.crop=cropAtZoom(current,1);zoom.value=1;renderImage(current);updateQuality(current)});root.querySelector('[data-change]').addEventListener('click',()=>files[current].click());const reframeLoaded=()=>{states.forEach((s,i)=>{if(!s.file)return;const centre=cropCentrePx(s);s.crop=cropAtZoom(i,s.zoom,centre);renderImage(i)});updateQuality(current);updateQualitySummary()};variant?.addEventListener('change',()=>{const p=variant.options[variant.selectedIndex]?.dataset.price||'';price.textContent=p;submitPrice.textContent=p;if(sizeInput)sizeInput.value=selectedSizeKey();if(applyAspect())requestAnimationFrame(()=>{applyLayout();reframeLoaded()})});titleInput?.addEventListener('input',()=>{const v=titleInput.value.trim();titlePreview.textContent=v||'DIN TITEL';titlePreview.classList.toggle('is-placeholder',!v);fitTitle()});if(form){form.enctype='multipart/form-data';form.dataset.psp5Owned='1';submitButton?.addEventListener('click',e=>e.stopPropagation());form.addEventListener('submit',async e=>{e.preventDefault();e.stopImmediatePropagation();if(submitting)return;const missing=states.findIndex(s=>!s.file||!s.crop);if(missing>-1){msg.textContent='Upload billede '+(missing+1)+', før du fortsætter.';select(missing);files[missing].click();return}sync();const qualities=states.map((s,i)=>qualityFor(i)),tooLow=qualities.findIndex(q=>!q||q.dpi<150);if(tooLow>-1){select(tooLow);updateQuality(tooLow);msg.textContent='Billede '+(tooLow+1)+' har for lav opløsning til print. Upload et bedre billede eller reducer zoom.';return}if(!selectedSize()||!personalizationId?.value||!cropInput.value||!shapesInput.value||TEMPLATE!=='standing-reference-5-photo-shapes-v5'){msg.textContent='Personaliseringen kunne ikke gemmes. Prøv igen.';return}const routeRoot=window.Shopify?.routes?.root||'/';submitting=true;submitButton.disabled=true;submitButton.classList.add('is-loading');msg.textContent='Uploader billeder…';try{const formData=new FormData(form);const addRes=await fetch(routeRoot+'cart/add.js',{method:'POST',body:formData,credentials:'same-origin',headers:{Accept:'application/json'}});const addData=await addRes.json().catch(()=>({}));if(!addRes.ok)throw new Error(addData?.description||addData?.message||'Kunne ikke tilføje den personlige plakat.');const cartRes=await fetch(routeRoot+'cart.js',{credentials:'same-origin',headers:{Accept:'application/json'}});if(!cartRes.ok)throw new Error('Kurven kunne ikke verificeres efter upload.');const cart=await cartRes.json();const pspId=personalizationId.value;const item=[...(cart.items||[])].reverse().find(x=>x?.properties?.['_PSP id']===pspId);const props=item?.properties||{};const filesOk=[1,2,3,4,5].every(n=>String(props['_Foto '+n]||'').trim().length>0);const metaOk=String(props['_PSP crop']||'').trim().length>0&&String(props['_PSP shapes']||'').trim().length>0&&props['_PSP template']===TEMPLATE&&props['_PSP layout']===TEMPLATE;if(!item||!filesOk||!metaOk){if(item?.key){await fetch(routeRoot+'cart/change.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:item.key,quantity:0})}).catch(()=>{});}throw new Error('Upload-verifikation fejlede. Ingen ufuldstændig personlig plakat blev godkendt.');}msg.textContent='Alle 5 billeder er verificeret. Åbner kurven…';window.location.assign(routeRoot+'cart');}catch(err){msg.textContent=err?.message||'Upload fejlede. Prøv igen.';submitting=false;submitButton.disabled=false;submitButton.classList.remove('is-loading');}},true);}if(sizeInput)sizeInput.value=selectedSizeKey();if(applyAspect())requestAnimationFrame(applyLayout);if('ResizeObserver'in window)new ResizeObserver(applyLayout).observe(poster);sync();updateQualitySummary();select(0)})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-content"]) return;
  try {
    
  class productPairs extends HTMLElement {
    connectedCallback() {
      fetch(this.dataset.url).
      then((response) => {
        if (!response.ok) {
          throw new Error("HTTP error! Status: ".concat(response.status));
        }
        return response.text();
      }).
      then((response) => {
        var frag = document.createDocumentFragment(),
          fetchedContent = document.createElement('div');
        frag.appendChild(fetchedContent);
        fetchedContent.innerHTML = response;

        var replacementContent = fetchedContent.querySelector("[data-id=\"".concat(CSS.escape(this.dataset.id), "\"]"));
        if (replacementContent) {
          this.innerHTML = replacementContent.innerHTML;
        }
      });
    }
  }

  customElements.define('product-pairs', productPairs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
 
class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
              theme.tooltip.load();
              const swiperContainer = this.querySelector('.swiper-container');
              const getID = swiperContainer.getAttribute("data-id");
              const swiperID = this.querySelector(`.swipercol-${getID}`);
              const spaceBetween = parseInt(swiperContainer.getAttribute('data-space-between'), 10);
              const perviewDesktop = swiperContainer.getAttribute('data-perview-desktop');
              if (swiperContainer) {
                new Swiper(swiperContainer, {
                  slidesPerView: "auto",
                  freeMode: false,
                  autoHeight: true,
                  calculateHeight:true,
                  freeModeSticky: true,
                  centeredSlides: false,
                  grabCursor: true,
                  watchSlidesVisibility: true,
                  watchSlidesProgress: true,
                  preloadImages: true,
                  updateOnImagesReady: true,
                  spaceBetween: spaceBetween,
                  observer: true,
                  observeParents: true,
                  parallax:true,
                  a11y: true,
                  keyboard: {
                    enabled: true,
                  },
                  breakpoints: {
                    320: {
                      slidesPerView: 2,
                      spaceBetween: 20
                    },
                    576: {
                      slidesPerView: 2,
                    },
                    768: {
                      slidesPerView: 3,
                    },
                    992: {
                      slidesPerView: perviewDesktop,
                    }
                  },
                  scrollbar: {
                    el: this.querySelector(".swiper-scrollbar"),
                  },
                  navigation: {
                    nextEl: this.querySelector(".swiper-button-next"),
                    prevEl: this.querySelector(".swiper-button-prev"),
                  },
                });
              } else {
                console.error('No element with class "swiper-container" found.');
              }
            }
            if(typeof jdgm !== 'undefined'){
              jdgm.customizeBadges();
            }
            if (window.SPR && theme.review ) {
              if ($('.shopify-product-reviews-badge').length > 0) {
                return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
              };
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 500px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-1"]) return;
  try {
    
class productPairsRight extends HTMLElement {
  connectedCallback() {
    fetch(this.dataset.url).
    then((response) => {
      if (!response.ok) {
        throw new Error("HTTP error! Status: ".concat(response.status));
      }
      return response.text();
    }).
    then((response) => {
      var frag = document.createDocumentFragment(),
        fetchedContent = document.createElement('div');
      frag.appendChild(fetchedContent);
      fetchedContent.innerHTML = response;

      var replacementContent = fetchedContent.querySelector("[data-id=\"".concat(CSS.escape(this.dataset.id), "\"]"));
      if (replacementContent) {
        this.innerHTML = replacementContent.innerHTML;
      }
    });
  }
}

customElements.define('product-pairsright', productPairsRight);

class BuyNow extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.handleClick.bind(this));
  }

  connectedCallback() {
    this.checkAgreement();
  }

  handleClick(event) {
    const agreeCheckbox = this.querySelector('.checkbox__input');
    const checkoutButton = this.querySelector('.product-form__buynow');
    
    if (event.target === agreeCheckbox || event.target === this.querySelector('.checkbox__label')) {
      if (agreeCheckbox.checked) {
        checkoutButton.classList.remove('disabled');
      } else {
        checkoutButton.classList.add('disabled');
      }
    }
  }
  checkAgreement() {
    const agreeCheckbox = this.querySelector('.checkbox__input');
    return agreeCheckbox.checked;
  }
}

customElements.define('buy-now', BuyNow);



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timeline"] && !Shopify.designMode) return;
  try {
    
  !function(){function e(e){this.element=e,this.blocks=this.element.getElementsByClassName("js-cd-block"),this.images=this.element.getElementsByClassName("js-cd-img"),this.contents=this.element.getElementsByClassName("js-cd-content"),this.offset=.8,this.hideBlocks()}e.prototype.hideBlocks=function(){if(!(!1 in document.documentElement))for(var e,t=this,s=0;s<this.blocks.length;s++)e=s,t.blocks[e].getBoundingClientRect().top>window.innerHeight*t.offset&&(t.images[e].classList.add("cd-is-hidden"),t.contents[e].classList.add("cd-is-hidden"))},e.prototype.showBlocks=function(){if(!(!1 in document.documentElement))for(var e,t=this,s=0;s<this.blocks.length;s++)e=s,t.contents[e].classList.contains("cd-is-hidden")&&t.blocks[e].getBoundingClientRect().top<=window.innerHeight*t.offset&&(t.images[e].classList.add("or-timeline__img--bounce-in"),t.contents[e].classList.add("or-timeline__content--bounce-in"),t.images[e].classList.remove("cd-is-hidden"),t.contents[e].classList.remove("cd-is-hidden"))};var t,s=document.getElementsByClassName("js-or-timeline"),n=[],i=!1;if(s.length>0){for(var o=0;o<s.length;o++)t=o,n.push(new e(s[t]));window.addEventListener("scroll",function(e){i||(i=!0,window.requestAnimationFrame?window.requestAnimationFrame(c):setTimeout(c,250))})}function c(){n.forEach(function(e){e.showBlocks()}),i=!1}}();

  } catch(e) { console.error(e); }
})();
})();
